<ng-container *ngIf="ValidarForallHeredada==true">
  <iframe [src]="urlSafe" width="" height=""></iframe>
</ng-container>

<ng-container *ngIf="ValidarForallHeredada==false">
  <div class="NO_FORALL" fxLayout="column" fxLayoutAlign="center center">
  <h1 class="h1 secondary-text"><p class="texto">{{'RESULTADOS.4ALLVIEJAS.SIN_4ALL_HEREDADAS' | translate}}</p></h1>
  </div>
</ng-container>
